<template>
  <figure>
    <v-chart :options="barLineOptions"
             class="cischart"
             auto-resize />
  </figure>
</template>
<script>
//* *********************summary***************************//
// html:
// <cisBarLine :title="title"
// :subTitle="subTitle"
// :x-list="xList"
// :y-list="yList"
// :series-name="seriseName"
// :series-data="seriseList" ></cisBarLine>
//
// js data:
// {
// title: '销量对比图',
// subTitle: '3个月内销量图',
// xList: ['9月','10月','11月'],
// seriseName: ['九阳', '苏泊尔'],
// seriseList: [[133,80,333],[0.1,0.9,0.3]],
// yList:[{
//     name: '销量'
// }, {
//     name: '乱价指数',
//     max: 1
// }]
// }
//* *********************summary***************************//

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
export default {
  name: 'cisBarLine',
  props: ['title', 'subTitle', 'xList', 'yList', 'seriesData', 'seriesName'],
  data() {
    return {
      yAxis: [],
      series: []
    }
  },
  mounted() {
    this.reloadSeries()
  },
  methods: {
    reloadSeries() {
      this.series = []
      if (this.seriesName && this.seriesName.length === 2) {
        this.series.push({
          type: 'bar',
          name: this.seriesName[0],
          data: this.seriesData[0]
        })
        this.series.push({
          type: 'line',
          yAxisIndex: 1,
          name: this.seriesName[1],
          data: this.seriesData[1]
        })
      } else {
        console.log('异常的bar-line参数')
      }

      if (this.yList && this.yList.length === 2) {
        this.yAxis = []
        this.yList.forEach((y, index) => {
          if (y.max) {
            this.yAxis.push({
              type: 'value',
              scale: true,
              name: y.name,
              min: 0,
              max: y.max,
              boundaryGap: [0.2, 0.2]
            })
          } else {
            this.yAxis.push({
              type: 'value',
              scale: true,
              name: y.name,
              min: 0,
              boundaryGap: [0.2, 0.2]
            })
          }
        })
      } else {
        this.yAxis = {
          type: 'value'
        }
      }
    }
  },
  computed: {
    barLineOptions() {
      this.reloadSeries()
      return {
        title: {
          text: this.title,
          subtext: this.subTitle
        },
        legend: {
          data: []
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        xAxis: {
          type: 'category',
          data: this.xList
        },
        yAxis: this.yAxis,
        series: this.series
      }
    }
  }
}
</script>
